export const ACCEP_SKHERA = 'ACCEP_SKHERA';
export const DECLINE_SKHERA = 'DECLINE_SKHERA';
export const ADD_SKHERA = 'ADD_SKHERA';
export const NOTIFICATIONS_SKHERA = 'NOTIFICATIONS_SKHERA';
export const ADD_NOTIFICATION = 'ADD_NOTIFICATION';
export const REMOVE_NOTIFICATION = 'REMOVE_NOTIFICATION';
export const ADD_LOCATION = 'ADD_LOCATION';
export const ADD_SKHERAS = 'ADD_SKHERAS';
export const GET_SKHERA = 'GET_SKHERA';
export const NOTIFICATION_SKHERA = 'NOTIFICATION_SKHERA';
export const SIGN_IN = 'SIGN_IN';
export const SIGN_OUT = 'SIGN_OUT';
export const SIGNUP_RIDER = 'SIGNUP_RIDER';
export const SIGNUP_CONSUMER = 'SIGNUP_CONSUMER';
export const UPDATE_USER = 'UPDATE_USER';
export const STATUS_ACTIF = 'actif';
export const COURSIER_ROLE = 'rider';
export const STATUS_INACTIF = 'inactif';
export const AUTH_FAILED = 'AUTH_FAILED';
export const SKHERA_FAILED = 'SKHERA_FAILED';
export const USER_FAILED = 'USER_FAILED';
export const SET_MENU = 'SET_MENU';

